import InternalBanner from '@/components/InternalBanner'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'
import { appLink } from '@app/config/appLink'
import { GuideCard } from '@app/modules/GuideV2/components/GuideCard'
import { useNavigate } from 'react-router-dom'
import SectionContent from '../../../../src/components/SectionContent'
import { GuideRecentArticles } from '../components/GuideRecentArticles'
import { GuideRecentTutorials } from '../components/GuideRecentTutorials'
import { guideContentTypeLabels, guideContentTypes, guideIconMap } from '../config/guide.config'
import { guideContentTypeLinkMap } from '../utils/guide.utils'
import UseCaseCardGrid from '@app/modules/HomeV2/components/UseCaseCardGrid'
import { USE_CASES } from '@app/modules/HomeV2/config/useCases.config'
import UseCaseCard from '@app/modules/HomeV2/components/UseCaseCard'
import { accentBgMap } from '@app/modules/HomeV2/types'

const guideLogoImg = `${PUBLIC_ASSETS_BASE_URL}/images/shared/rex_guide_home_logo.svg`

export const GuideGetStartedPage = () => {
  const navigate = useNavigate()
  return (
    <div className="pb-20">
      <InternalBanner
        image={guideLogoImg}
        description="Tutorials, methods, and reference material for Resilience Explorer®"
      />
      <div className="bg-neutral-200 pt-4 pb-10">
        <SectionContent>
          <Tabs defaultValue="content-types">
            <TabsList className="rounded-xl bg-neutral-100 p-1">
              <TabsTrigger value="content-types">Content types</TabsTrigger>
              <TabsTrigger value="learning-pathway">Learning pathway</TabsTrigger>
            </TabsList>

            <TabsContent value="content-types" className="mt-4">
              <Carousel opts={{ align: 'start', loop: false }} className="w-full max-w-5xl mx-auto">
                <CarouselContent className="-ml-4">
                  {guideContentTypes.map((type) => {
                    return (
                      <CarouselItem key={type} className="pl-4 md:basis-1/2 lg:basis-1/3">
                        <GuideCard
                          title={guideContentTypeLabels[type]}
                          description="Tutorials, methods, and reference material for Resilience Explorer®"
                          type={type}
                          icon={guideIconMap[type]}
                          onActionClick={() => {
                            const guideLinkKey = guideContentTypeLinkMap[type]

                            if (!guideLinkKey) return

                            navigate(appLink[guideLinkKey].path)
                          }}
                        />
                      </CarouselItem>
                    )
                  })}
                </CarouselContent>
                <CarouselPrevious className="-left-4 lg:-left-10 rounded-md" size={'icon'} />
                <CarouselNext className="-right-4 lg:-right-10 rounded-md" size={'icon'} />
              </Carousel>
            </TabsContent>

            <TabsContent value="learning-pathway" className="mt-4">
              <UseCaseCardGrid>
                {USE_CASES.map((useCase) => (
                  <UseCaseCard
                    key={useCase.id}
                    title={useCase.title}
                    description={useCase.tagline}
                    Icon={useCase.iconComponent}
                    accentClassName={accentBgMap[useCase.accentColor]}
                    onLearnMore={() =>
                      navigate(`${appLink.homeUseCases.path}/${useCase.id}/overview`)
                    }
                    showBody={false}
                  />
                ))}
              </UseCaseCardGrid>
            </TabsContent>
          </Tabs>
        </SectionContent>
      </div>
      <GuideRecentTutorials />
      <GuideRecentArticles />
    </div>
  )
}
